// extracted by mini-css-extract-plugin
export var standaloneTable = "_ja-0";
export var standaloneTableWithBodyFill = "_ja-1";
export var withExtraHeader = "_ja-2";